import { useEffect } from "react";

import { useCommand, useSelector } from "@tdp/core";

import { IAuthenticatedImage } from "./abstractions";
import { authenticatedImageSlice } from "./slice";

export function useAuthenticateImages(paths: string[]) {
  const loadAuthenticatedImage = useCommand(commands => commands.authenticatedImageCommands.loadAuthenticatedImage);
  const unloadAuthenticatedImage = useCommand(commands => commands.authenticatedImageCommands.unloadAuthenticatedImage);

  useEffect(() => {
    paths.forEach(path => { loadAuthenticatedImage(path); });
    return () => { paths.forEach(path => { unloadAuthenticatedImage(path); }); };
  }, [paths.join('|')]);

  return useSelector((state) => {
    return paths.map(path => {
      const img = authenticatedImageSlice.selectors.selectAuthenticatedImage(state, path);
      return img ?? {
        type: 'error',
        path,
        error: 'image_not_found'
      } as IAuthenticatedImage;
    });
  });
}

export function useAuthenticateImage(path: string | undefined) {
  const result = useAuthenticateImages(path ? [path] : []);
  return result[0];
}
